"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitTestProfile = void 0;
exports.unitTestProfile = {
    name: 'unitTest',
    methods: ['testFromPath', 'testFromSource'],
};
//# sourceMappingURL=profile.js.map